import { FC } from 'react';
import NudosConfirmActionModal from '../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';

interface ICancelOrderModalProps {
  changeShowModal?: () => void;
  showModal?: boolean;
  onConfirm?: () => void | Promise<void>;
  loadingConfirmation?: boolean;
}

const CancelOrderModal: FC<ICancelOrderModalProps> = ({
  changeShowModal,
  showModal,
  onConfirm,
  loadingConfirmation = false
}) => {
  const modalTitle = '¿Estás seguro que quieres cancelar la orden?';
  const modalText = 'Esta acción cancelará toda la orden incluído los envíos activos. Puedes revertirla posteriormente.';
  const firstButtonText = 'Volver atrás';
  const secondButtonText = 'Si, continuar';

  const closeModal = () => {
    changeShowModal?.();
  };

  const handleConfirm = () => {
    void Promise.resolve(onConfirm?.());
  };

  return (
    <>
      {showModal && (
        <NudosConfirmActionModal
          modalTitle={modalTitle}
          modalText={modalText}
          firstButtonText={firstButtonText}
          secondButtonText={secondButtonText}
          firstButtonAction={closeModal}
          secondButtonAction={handleConfirm}
          isLoading={loadingConfirmation}
          customHeight="254px"
        />
      )}
    </>
  );
};

export default CancelOrderModal;
